import { ReactElement } from 'react'

import { useI18n } from '@tribeplatform/react-components/i18n'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { SlateRenderer } from '@tribeplatform/react-slate-kit/components'
import { useSlate } from '@tribeplatform/react-slate-kit/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'

import { ErrorBoundary } from '../../../Error/ErrorBoundry.js'
import { KitchenSink } from './KitchenSink.js'
import { sampleHomeSidebarSlate } from './sampleHomeSidebar.js'
import { SamplePost } from './SamplePost.js'

export const SampleContent = (): ReactElement => {
  const { context } = useSlate()
  const {
    data: {
      member: { id: authMemberId },
    },
  } = useAuthToken()
  const { $t } = useI18n()

  return (
    <Container size="lg" padding={{ vertical: 'md' }}>
      <Container size="lg" direction="grid">
        <Container size="md">
          <SectionHeader
            title={$t({
              defaultMessage: 'Sample community',
              id: 'Admin.Customizer.Preview.SampleCommunity.Title',
            })}
            description={$t({
              defaultMessage:
                'This page shows how elements within your community will be shown to your members.',
              id: 'Admin.Customizer.Preview.SampleCommunity.Description',
            })}
          />

          <ErrorBoundary>
            <SamplePost />
          </ErrorBoundary>

          <ErrorBoundary>
            <KitchenSink />
          </ErrorBoundary>
        </Container>

        <Container size="sm">
          <SlateRenderer
            slate={sampleHomeSidebarSlate}
            context={{ ...context, memberId: authMemberId }}
          />
        </Container>
      </Container>
    </Container>
  )
}

// Default exports are needed for React.lazy
// See https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default SampleContent
